import { devices } from '@src/styles/theme';
import styled from 'styled-components';
import Aside from '@src/components/Organism/Aside/Index';
import PageCategory from '@src/components/Molecules/PageCategory';
import CMSelector from '@src/components/Atoms/CMSelector';
import { useRecoilState } from 'recoil';
import filterAtom from '@src/recoils/atom/filter';
import { useCallback } from 'react';
import {
  filterBloodDonationTypeList,
  filterBloodList,
  filterSortList,
} from '@src/data/filter';
import Poster from '@src/components/Organism/Blood-home/Poster';

type Props = {
  isLoading?: boolean;
  isSide?: boolean;
  children: React.ReactNode;
  AsideIsListPage?: boolean;
  AsideDisabledTop?: boolean;
  AsideDisabledBody?: boolean;
  AsideDisabledBottom?: boolean;
  mainText: string;
  href: string;
  postCommunity?: () => void;
  isActive?: boolean;
};

const PageTemplate = ({
  isLoading,
  isSide,
  children,
  AsideIsListPage = true,
  AsideDisabledTop = false,
  AsideDisabledBody = true,
  mainText,
  href,
  postCommunity,
  isActive,
}: Props) => {
  const [filter, setFilter] = useRecoilState(filterAtom);
  const filterLabel = (type: string) => {
    const want = filter.filter((e) => e.type === type);
    return want[0].label;
  };
  const onChangefilter = useCallback((label: string, type: string) => {
    const otherList = filter.filter((e) => e.type !== type);
    setFilter([...otherList, { label, type }]);
  }, []);
  return (
    <>
      <Container>
        {isSide ? (
          <>
            {!isLoading && (
              <SelectWrap>
                <CMSelector
                  defaultName={filterLabel('abo')}
                  ItemList={filterBloodList}
                  onChangeFilter={onChangefilter}
                />
                <CMSelector
                  defaultName={filterLabel('bloodProduct')}
                  ItemList={filterBloodDonationTypeList}
                  onChangeFilter={onChangefilter}
                />
                <CMSelector
                  defaultName={filterLabel('sortBy')}
                  ItemList={filterSortList}
                  onChangeFilter={onChangefilter}
                />
              </SelectWrap>
            )}
            <Wrap>
              <Flex2>{children}</Flex2>
              <Flex1>
                <Aside
                  isListPage={AsideIsListPage}
                  disabledBody={AsideDisabledBody}
                  disabledTop={AsideDisabledTop}
                  postCommunity={postCommunity}
                  isActive={isActive}
                />
              </Flex1>
            </Wrap>
          </>
        ) : (
          <>
            {/* TODO: 페이지에서 카테고리 명 프롭을 주자. */}
            <OnlyViewWrap>
              <OnlyViewList>
                <li>only view</li>
              </OnlyViewList>
            </OnlyViewWrap>
            <Wrap>
              <Flex2>
                <Poster />
                <>{children}</>
              </Flex2>
              <Flex1>
                <Aside
                  isListPage={AsideIsListPage}
                  disabledBody={AsideDisabledBody}
                  disabledTop={AsideDisabledTop}
                  postCommunity={postCommunity}
                  isActive={isActive}
                />
              </Flex1>
            </Wrap>
          </>
        )}
      </Container>
    </>
  );
};

const SelectWrap = styled.div`
  display: flex;
  gap: 10px;
  margin: 20px 0px;
  @media ${devices.tablet} {
    padding: 0px 1.6rem;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  @media ${devices.tablet} {
    max-width: 100%;
  }
`;

const Wrap = styled.section`
  display: flex;
  max-width: 100%;
  @media ${devices.tablet} {
    display: block;
  }
`;

const Flex1 = styled.div`
  flex: 1;
  @media ${devices.tablet} {
    flex: 0;
  }
`;

const Flex2 = styled.div`
  flex: 2;
  @media ${devices.tablet} {
    background-color: #f9f9f9;
  }
`;

const OnlyViewWrap = styled.div`
  display: flex;
  gap: 10px;
  margin: 20px 0px;
  @media ${devices.tablet} {
    display: none;
  }
`;

const OnlyViewList = styled.ul`
  > li {
    visibility: hidden;
    padding: 5px 12px;
  }

  @media ${devices.tablet} {
    display: none;
  }
`;

export default PageTemplate;
